export default __webpack_public_path__ + "static/media/sc-bra.c2b17a09.svg";